/* Vindrax review widget (vx-rev): renders all reviews client-side in Judge.me's exact markup. No external calls except optional hls.js for the one review video. */
(function () {
  'use strict';
  var STAR_ON = '', STAR_OFF = '', STAR_HALF = '';
  function $(r, s) { return r.querySelector(s); }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function tpl(w, name) {
    var t = w.querySelector('template[data-vx-tpl="' + name + '"]');
    return t.content.firstElementChild.cloneNode(true);
  }
  function fmtAvg(a) { return (Math.round(parseFloat(a) * 10) / 10).toFixed(1); }
  function svDate(d) { /* local date like Judge.me, Swedish ISO format yyyy-mm-dd */
    var t = new Date(String(d).replace(' UTC', 'Z').replace(' ', 'T'));
    if (isNaN(t)) return String(d).slice(0, 10);
    function p(n) { return (n < 10 ? '0' : '') + n; }
    return t.getFullYear() + '-' + p(t.getMonth() + 1) + '-' + p(t.getDate());
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init(w) {
    if (w.__vx) return; w.__vx = 1;
    var assetBase = w.getAttribute('data-img').replace(/vx-rev-img-vid-664ca56d\.jpg.*$/, '');
    function img(fn, width) { return assetBase + fn + (width ? '?width=' + width : ''); }
    var prods = {};
    try { prods = JSON.parse($(w, 'script[data-vx-products]').textContent); } catch (e) {}
    var root = $(w, '.jm-review-widget');
    var list = $(root, '[data-vx=list]'), pager = $(root, '[data-vx=pager]'), pcl = $(pager, '.jm-cluster');
    var S = { all: [], view: [], page: 1, sort: 'pictures_first', rating: 0, per: 5 };

    fetch(w.getAttribute('data-src'), { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (D) {
      S.D = D; S.per = D.per_page || 5;
      D.reviews.forEach(function (r, i) { r._i = i; r.t_ = Date.parse(String(r.d).replace(' UTC', 'Z').replace(' ', 'T')) || 0; });
      S.all = D.reviews;
      $(root, '[data-vx=avg]').textContent = fmtAvg(D.avg);
      $(root, '[data-vx=count]').textContent = D.count + (D.count === 1 ? ' recension' : ' recensioner');
      $$(root, '[data-vx-ai]').forEach(function (b) {
        if (!D.ai) { b.remove(); return; }
        $$(b, '[data-vx=ai]').forEach(function (p) { p.textContent = D.ai; });
      });
      buildGrid(D);
      $(root, '[data-vx=sort]').value = S.sort;
      apply();
    }).catch(function (e) { if (window.console) console.warn('vx-rev', e); });

    /* ---------- photo carousel */
    function media(r) {
      var m = [];
      if (r.vid) m.push({ vid: r.vid });
      r.p.forEach(function (f) { m.push({ img: f }); });
      return m;
    }
    function buildGrid(D) {
      var g = $(root, '[data-vx=grid]'), cont = $(g, '.jm-media-grid__container'), n = 0, flat = [];
      D.reviews.forEach(function (r) { r.p.forEach(function (f, j) { flat.push({ r: r, j: j + (r.vid ? 1 : 0), f: f }); }); });
      flat = flat.slice(0, D.grid_max || 20);
      if (!flat.length) { g.remove(); return; }
      cont.setAttribute('aria-label', 'Miniatyrer för ' + flat.length + ' objekt');
      flat.forEach(function (x, k) {
        var b = tpl(w, 'gitem');
        b.setAttribute('aria-label', 'Gå till objekt ' + (k + 1));
        b.setAttribute('aria-pressed', k === 0 ? 'true' : 'false');
        var im = $(b, 'img'); im.src = img(x.f, 160); im.srcset = img(x.f, 160) + ' 100w, ' + img(x.f, 240) + ' 200w'; im.alt = 'Miniatyr ' + (k + 1);
        b.addEventListener('click', function (e) { e.stopPropagation(); openLB(x.r, x.j); });
        cont.appendChild(b);
      });
      var prev = $(g, '[data-vx=gprev]'), next = $(g, '[data-vx=gnext]');
      /* drop listeners other theme scripts may have bound to these arrows (clone = clean node) */
      var p2 = prev.cloneNode(true), n2 = next.cloneNode(true); prev.replaceWith(p2); next.replaceWith(n2); prev = p2; next = n2;
      function upd() { prev.hidden = cont.scrollLeft < 4; next.hidden = cont.scrollLeft + cont.clientWidth >= cont.scrollWidth - 4; }
      prev.addEventListener('click', function () { cont.scrollBy({ left: -cont.clientWidth * 0.8, behavior: 'smooth' }); });
      next.addEventListener('click', function () { cont.scrollBy({ left: cont.clientWidth * 0.8, behavior: 'smooth' }); });
      cont.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); setTimeout(upd, 50); upd();
    }

    /* ---------- one review item */
    function stars(el, rating) {
      el.setAttribute('aria-label', rating + ' av 5 stjärnor');
      $$(el, '.jm-star-rating__font-icon').forEach(function (s, k) {
        s.textContent = rating >= k + 1 ? STAR_ON : (rating > k ? STAR_HALF : STAR_OFF);
      });
    }
    function renderItem(r, withMedia) {
      var it = tpl(w, 'item');
      stars($(it, '[data-vx=stars]'), r.r);
      $(it, '[data-vx=initial]').textContent = r.i;
      var nm = $(it, '[data-vx=name]'); nm.textContent = r.n; nm.title = r.n;
      if (!r.v) $(it, '[data-vx=verified]').remove();
      $(it, '[data-vx=date]').textContent = svDate(r.d);
      var body = $(it, '[data-vx=body]');
      body.innerHTML = (r.t ? '<b>' + esc(r.t) + '</b><br>' : '') + r.b;
      var th = $(it, '[data-vx=thumbs]');
      if (withMedia && media(r).length) {
        media(r).forEach(function (m, j) {
          var b;
          if (m.vid) { b = tpl(w, 'vthumb'); $(b, 'img').src = img('vx-rev-img-vid-' + m.vid.slice(0, 8) + '.jpg', 480); $(b, 'img').alt = 'Videominiatyr'; }
          else { b = tpl(w, 'thumb'); var im = $(b, 'img'); im.src = img(m.img, 160); im.srcset = img(m.img, 160) + ' 1x, ' + img(m.img, 480) + ' 2x'; im.alt = 'Bild från recensionen'; }
          var hit = $(b, '[role=button]');
          hit.addEventListener('click', function (e) { e.stopPropagation(); openLB(r, j); });
          hit.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLB(r, j); } });
          th.appendChild(b);
        });
      } else th.remove();
      var card = $(it, '[data-vx=card]');
      var pr = r.u && prods[r.u];
      if (withMedia && pr && pr.url) {
        $(card, '[data-vx=card-title]').textContent = pr.title;
        var ci = $(card, '[data-vx=card-img]'); ci.src = pr.img || ''; ci.alt = pr.title;
        $$(card, '[data-vx=card-link],[data-vx-link]').forEach(function (a) { a.addEventListener('click', function () { location.href = pr.url; }); });
      } else card.remove();
      return it;
    }

    /* ---------- list, sort, filter, pages */
    function apply() {
      var v = S.all.slice();
      if (S.rating) v = v.filter(function (r) { return r.r === S.rating; });
      var hasM = function (r) { return (r.p.length || r.vid) ? 1 : 0; };
      var byDate = function (a, b) { return a.t_ < b.t_ ? 1 : a.t_ > b.t_ ? -1 : a._i - b._i; };
      switch (S.sort) {
        case 'created_at': v.sort(byDate); break;
        case 'highest_rating': v.sort(function (a, b) { return b.r - a.r || byDate(a, b); }); break;
        case 'lowest_rating': v.sort(function (a, b) { return a.r - b.r || byDate(a, b); }); break;
        case 'with_pictures': v = v.filter(hasM).sort(function (a, b) { return a._i - b._i; }); break;
        case 'videos_first': v.sort(function (a, b) { return (b.vid ? 1 : 0) - (a.vid ? 1 : 0) || a._i - b._i; }); break;
        case 'most_helpful': v.sort(function (a, b) { return (b.h || 0) - (a.h || 0) || a._i - b._i; }); break;
        default: v.sort(function (a, b) { return a._i - b._i; }); /* pictures_first = Judge.me order */
      }
      S.view = v; S.page = 1; render(false);
    }
    function render(scroll) {
      list.innerHTML = '';
      var start = (S.page - 1) * S.per;
      S.view.slice(start, start + S.per).forEach(function (r) { list.appendChild(renderItem(r, true)); });
      renderPager();
      if (scroll) { var y = w.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: y, behavior: 'smooth' }); }
    }
    function pages(cur, tot) {
      if (tot <= 6) { var a = []; for (var i = 1; i <= tot; i++) a.push(i); return a; }
      if (cur <= 3) return [1, 2, 3, 4, '…', tot];
      if (cur >= tot - 2) return [1, '…', tot - 3, tot - 2, tot - 1, tot];
      return [1, '…', cur - 1, cur, cur + 1, '…', tot];
    }
    function renderPager() {
      pcl.innerHTML = '';
      var tot = Math.ceil(S.view.length / S.per);
      if (tot <= 1) { pager.style.display = 'none'; return; }
      pager.style.display = '';
      var prev = tpl(w, 'pprev'), next = tpl(w, 'pnext');
      setDis(prev, S.page === 1); setDis(next, S.page === tot);
      prev.addEventListener('click', function () { if (S.page > 1) { S.page--; render(true); } });
      next.addEventListener('click', function () { if (S.page < tot) { S.page++; render(true); } });
      pcl.appendChild(prev);
      pages(S.page, tot).forEach(function (p) {
        if (p === '…') { var e = tpl(w, 'pell'); e.textContent = '...'; pcl.appendChild(e); return; }
        var b = tpl(w, p === S.page ? 'pact' : 'ppage');
        $(b, '.jm-text').textContent = p; b.setAttribute('aria-label', 'Gå till sida ' + p);
        if (p === S.page) b.setAttribute('aria-current', 'page'); else b.removeAttribute('aria-current');
        b.addEventListener('click', function () { S.page = p; render(true); });
        pcl.appendChild(b);
      });
      pcl.appendChild(next);
    }
    function setDis(b, d) {
      if (d) { b.disabled = true; b.classList.add('jm-button--disabled'); }
      else { b.disabled = false; b.removeAttribute('disabled'); b.classList.remove('jm-button--disabled'); }
    }

    /* ---------- header controls */
    $(root, '[data-vx=write]').addEventListener('click', function () { location.href = w.getAttribute('data-write'); });
    var fbtn = $(root, '[data-vx=filters]'), panel = $(root, '[data-vx=panel]');
    fbtn.addEventListener('click', function () {
      var open = panel.style.display === 'none';
      panel.style.display = open ? '' : 'none';
      fbtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      fbtn.classList.toggle('jm-custom-answer-filter--active', open);
    });
    var clear = $(root, '[data-vx=clear]');
    $$(root, '[data-vx=rate]').forEach(function (l) {
      var inp = $(l, 'input');
      inp.addEventListener('change', function () {
        S.rating = parseInt(inp.value, 10);
        $$(root, '[data-vx=rate]').forEach(function (x) { x.classList.toggle('vx-on', x === l); x.classList.toggle('jm-rating-filter__tag--selected', x === l); });
        clear.classList.remove('jm-filter-panel__clear-btn--hidden'); clear.removeAttribute('aria-hidden'); clear.tabIndex = 0;
        apply();
      });
    });
    clear.addEventListener('click', function () {
      S.rating = 0;
      $$(root, '[data-vx=rate]').forEach(function (x) { x.classList.remove('vx-on', 'jm-rating-filter__tag--selected'); $(x, 'input').checked = false; });
      clear.classList.add('jm-filter-panel__clear-btn--hidden'); clear.setAttribute('aria-hidden', 'true'); clear.tabIndex = -1;
      apply();
    });
    $(root, '[data-vx=sort]').addEventListener('change', function (e) { S.sort = e.target.value; apply(); });

    /* ---------- lightbox */
    var LB = null, lbR = null, lbI = 0, hlsP = null;
    function lbEl() {
      if (LB) return LB;
      LB = tpl(w, 'lb'); document.body.appendChild(LB);
      $(LB, '[data-vx=lclose]').addEventListener('click', closeLB);
      $(LB, '[data-vx=loverlay]').addEventListener('click', closeLB);
      $(LB, '.jdgm-modal__container').addEventListener('click', function (e) { if (e.target === e.currentTarget) closeLB(); });
      $(LB, '[data-vx=lprev]').addEventListener('click', function () { go(lbI - 1); });
      $(LB, '[data-vx=lnext]').addEventListener('click', function () { go(lbI + 1); });
      document.addEventListener('keydown', function (e) {
        if (LB.style.display === 'none') return;
        if (e.key === 'Escape') closeLB(); else if (e.key === 'ArrowLeft') go(lbI - 1); else if (e.key === 'ArrowRight') go(lbI + 1);
      });
      return LB;
    }
    function loadHls(cb) {
      if (window.Hls) return cb();
      if (!hlsP) { hlsP = []; var s = document.createElement('script'); s.src = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.5.13/hls.min.js'; s.onload = function () { hlsP.forEach(function (f) { f(); }); }; document.head.appendChild(s); }
      hlsP.push(cb);
    }
    function openLB(r, j) {
      var L = lbEl(); lbR = r;
      var M = media(r), sl = $(L, '[data-vx=slides]'), th = $(L, '[data-vx=lthumbs]');
      sl.innerHTML = ''; th.innerHTML = '';
      M.forEach(function (m, k) {
        var s = tpl(w, 'slide');
        var fig = $(s, 'figure');
        if (m.vid) {
          fig.innerHTML = '<div class="jm-media__frame" style="--e256a03a:100%"><video controls playsinline preload="none" poster="' + img('vx-rev-img-vid-' + m.vid.slice(0, 8) + '.jpg') + '"></video></div>';
          s.__vid = m.vid;
        } else {
          var u = img(m.img, 1024);
          fig.setAttribute('style', "--18d765da: 100%; --65265b7a: auto; --168bd92f: url('" + u + "') lightgray 50% / cover no-repeat;");
          $(fig, 'img').src = u; $(fig, 'img').alt = '';
        }
        sl.appendChild(s);
        var t = tpl(w, 'lthumb'); var ti = $(t, 'img');
        ti.src = m.vid ? img('vx-rev-img-vid-' + m.vid.slice(0, 8) + '.jpg', 160) : img(m.img, 160); ti.removeAttribute('srcset');
        t.setAttribute('aria-label', 'Gå till objekt ' + (k + 1));
        t.addEventListener('click', function (e) { e.stopPropagation(); go(k); });
        th.appendChild(t);
      });
      var lc = $(L, '[data-vx=lcontent]'); lc.innerHTML = ''; lc.appendChild(renderItem(r, false));
      L.style.display = ''; document.documentElement.style.overflow = 'hidden';
      go(j || 0, true);
    }
    function go(k, first) {
      var M = media(lbR); if (k < 0 || k >= M.length) return;
      var prevI = lbI; lbI = k;
      $$(LB, '[data-vx=slides] .jm-carousel__slide').forEach(function (s, i) {
        var v = $(s, 'video'); if (v && i !== k) v.pause();
        s.className = 'jm-carousel__slide ' + (i === k ? 'is-entering ' + (first ? 'is-zoom' : (k > prevI ? 'is-next' : 'is-prev')) : 'is-idle');
        if (i === k && s.__vid && v && !v.__on) {
          v.__on = 1; var src = 'https://review-videos.judgeme.com/' + s.__vid + '/playlist.m3u8';
          if (v.canPlayType('application/vnd.apple.mpegurl')) v.src = src;
          else loadHls(function () { if (window.Hls && window.Hls.isSupported()) { var h = new window.Hls(); h.loadSource(src); h.attachMedia(v); } });
        }
      });
      $$(LB, '[data-vx=lthumbs] .jm-media-grid__item').forEach(function (t, i) { t.classList.toggle('jm-media-grid__item--active', i === k); });
      $(LB, '[data-vx=lprev]').disabled = k === 0; $(LB, '[data-vx=lnext]').disabled = k === M.length - 1;
      $(LB, '[data-vx=lprev]').style.display = M.length > 1 ? '' : 'none'; $(LB, '[data-vx=lnext]').style.display = M.length > 1 ? '' : 'none';
    }
    function closeLB() {
      if (!LB) return;
      $$(LB, 'video').forEach(function (v) { v.pause(); });
      LB.style.display = 'none'; document.documentElement.style.overflow = '';
    }
  }
  function boot() { $$(document, '.vx-rev[data-src]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
